'use strict';

const { initCsrfBootstrap } = require('public/js/lib/csrf/bootstrap');
const { initBotGuard } = require('public/js/lib/request');
const { initSessionAttribution, openAttributionGate } = require('public/js/lib/session-attribution');
const { openSupplierReadyGate } = require('public/js/lib/supplier-bootstrap');

/**
 * Bot guard, supplier/attribution gates, then CSRF. Call after window.$ajax is set.
 * Shared by main and main-legacy so gate wiring is not duplicated.
 *
 * @returns {void}
 */
function initPageLoadGates() {
	initBotGuard();
	// Gates must exist before CSRF installs the deferral wrapper.
	openSupplierReadyGate();
	openAttributionGate();
	const csrfReady = initCsrfBootstrap();
	initSessionAttribution(csrfReady);
}

module.exports = {
	initPageLoadGates,
};
